<template>
    <div :class="{ constrain: showSidebar }">
        <!-- <div class='nav-bg' /> -->
        <Navigation v-if="showNav" v-model="showSidebar" />

        <div id="main" :class="{ main: showNav }">
            <!-- <transition name="opacity"> -->
            <router-view />
            <!-- </transition> -->
        </div>

        <Sidebar v-if="showSidebar" v-model="showSidebar" />
        <LogInModule v-if="hasLogin" :show="showLogInModal" />
        <Dialog />
        <NotificationModule />
        <IntercomChat />
        <Chat v-if="mountChat" />

        <ScrollToTop />
    </div>
</template>

<script>
import Navigation from './components/navigation/Navigation';
import Sidebar from './components/navigation/Sidebar';
import LogInModule from './shared/loginmodule/LogInModule';
import NotificationModule from './components/smart/NotificationModule/NotificationModule';
import ScrollToTop from './components/miscellaneous/ScrollToTop';

// Utils
import AuthService from '~/services/AuthService';
import UniversityService from '~/services/UniversityService';
import BackgroundProcessService from '~/services/BackgroundProcessesService';
import { redirectToHttps } from '~/utils/urlUtils';
import { HAS_LOGIN, HAS_CHAT, HAS_FORCED_LOGIN } from '~/router';
import Chat from './components/chat/Chat';
import IntercomChat from './components/miscellaneous/IntercomChat';

export default {
    components: {
        IntercomChat,
        Chat,
        Navigation,
        Sidebar,
        LogInModule,
        NotificationModule,
        ScrollToTop,
    },
    data: () => ({
        showSidebar: false,
        blacklist: ['/login', '/recover-password', '/redirect', '/activate-user'],
        hasLogin: HAS_LOGIN,
        hasChat: HAS_CHAT,
    }),
    computed: {
        showNav() {
            return this.blacklist.filter(el => el === this.$route.path).length === 0;
        },
        showLogInModal() {
            return (
                this.$interfaces.logInModule.isOpen() &&
                !this.$interfaces.logInModule.getDisabledPopup()
            );
        },
        mountChat() {
            return this.hasChat && this.$interfaces.logInModule.isLoggedIn();
        },
    },
    created() {
        // Redirect to production
        if (process.env.NODE_ENV === 'production') {
            redirectToHttps();
        }
    },
    mounted() {
        // Change document title to university title
        UniversityService.initialize();

        // Initialize user-identity for logging
        if (AuthService.isAuthenticated()) {
            this.$interfaces.logInModule.setIsLoggedIn(true);
        }

        if (HAS_FORCED_LOGIN) {
            // Initialize logIn popup after X amount of seconds
            BackgroundProcessService.scheduleLogInPopup();
            this.$interfaces.logInModule.setForcedLogin();
        }
    },
};
</script>

<style>
.main {
    margin-top: 70px;
}

@media only screen and (max-width: 1000px) {
    .main {
        margin-top: 60px;
    }
}
</style>
